import { type HttpRequest } from '@angular/common/http';

export function withBearerToken<T>(request: HttpRequest<T>, token: string): HttpRequest<T> {
  return request.clone({
    headers: request.headers.set('Authorization', `Bearer ${token}`),
  });
}
